// extracted by mini-css-extract-plugin
export default {"readme":"markdown_readme__RWuLR"};